import { normalizeCurrencyCode } from '@/src/helpers';
import { Flex, Text } from '@/src/ui-components';
import { AlertCircle } from 'lucide-react';
import { RipplePathFindResponse } from 'xrpl';
import { TokenSelectorsFormValues } from './token-selectors/token-selectors.types';

type PathFindingResultsProps = {
  pathFindResult: RipplePathFindResponse['result'];
} & Pick<TokenSelectorsFormValues, 'from' | 'to'>;

export const PathFindingResults = ({ from, to, pathFindResult }: PathFindingResultsProps) => {
  if (!pathFindResult?.alternatives?.length) {
    return (
      <Flex align="center" gap={2} className="rounded-lg bg-muted p-3 dark:bg-red-900/20">
        <AlertCircle size={16} className="text-red-600 dark:text-red-400" />
        <Text size="sm" className="text-red-800 dark:text-red-200">
          Could not find a payment path
        </Text>
      </Flex>
    );
  }

  const hasExchangeRate = +to.amount !== -1;

  return (
    <Flex direction="col" gap={2} className="mb-4 rounded-lg bg-muted p-3">
      {hasExchangeRate && (
        <Flex justify="between">
          <Text size="sm" className="text-muted-foreground">
            Exchange Rate:
          </Text>
          <Text size="sm" weight="medium" className="font-mono">
            {normalizeCurrencyCode(from.token)} = {(+to.amount / +from.amount).toFixed(6)}{' '}
            {normalizeCurrencyCode(to.token)}
          </Text>
        </Flex>
      )}

      <Flex justify="between">
        <Text size="sm" className="text-muted-foreground">
          Slippage:
        </Text>
        <Text weight="medium" className="font-mono">0.5%</Text>
      </Flex>

      <Flex justify="between">
        <Text size="sm" className="text-muted-foreground">
          Path:
        </Text>
        <Text weight="medium" className="font-mono">
          {pathFindResult.alternatives[0].paths_computed.length} path(s) found
        </Text>
      </Flex>
    </Flex>
  );
};
